export const environment = {
  production: false,
  recaptchaSiteKey: '6LcxMcQsAAAAAPv8JfwsXp7HcwvXrXRmnp3rbgP7',
  authServer: 'https://api-hml.greenvillage-gc.net',
  apiUrl: 'https://api-hml.greenvillage-gc.net',
  redirectUri: 'https://hml.greenvillage-gc.net/callback',
  oauth2: {
    clientCredentials: {
      clientId: 'backend-client',
      clientSecret: 'hml-2026-password'
    },
    authorizationCode: {
      clientId: 'public-client',
      redirectUri: 'https://hml.greenvillage-gc.net/callback'
    }
  }
};
